export default __webpack_public_path__ + "static/diag-wave-628fc68a20b9f2f7c20f721317588d85.webp";